import axios from "axios";
import { router } from "@/router";

// Get API URL from environment or use relative path
const API_URL = process.env.VUE_APP_API_URL || "/api";

const instance = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default instance;

// Global 401 handler: redirect to login when token is invalid/expired
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    if (status === 401) {
      const message = String(error?.response?.data?.message ?? "").toLowerCase();
      const errorDetail = String(error?.response?.data?.error ?? "").toLowerCase();
      const errorCode = String(error?.response?.data?.code ?? "").toLowerCase();
      const shouldForceLogout =
        message.includes("token") ||
        errorDetail.includes("token") ||
        message.includes("non authentifié") ||
        message.includes("unauthenticated") ||
        errorCode.includes("token");

      if (shouldForceLogout) {
        try {
          localStorage.removeItem("access_token");
        } catch (_) {
          /* ignore storage errors */
        }
        // Avoid infinite redirect loops
        if (router.currentRoute?.value?.path !== "/") {
          router.push("/");
        }
      }
    }
    return Promise.reject(error);
  }
);
